var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a",
        {
          staticClass: "button success",
          attrs: { id: "show-modal" },
          on: {
            click: function($event) {
              return _vm.toggleModal()
            }
          }
        },
        [_vm._v("\n    Request Ad Creation\n  ")]
      ),
      _vm._v(" "),
      _c("confirm-modal", {
        ref: "confirmModal",
        attrs: {
          "requisition-id": _vm.requisitionId,
          "csrf-token": _vm.csrfToken,
          type: _vm.type
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15069138", { render: render, staticRenderFns: staticRenderFns })
  }
}